export const printer = () => (
  <path
    d="M6 9V2h12v7M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2M6 14h12v8H6v-8z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
